import React from "react";
import WspolnotaRozliczenieTHead from "./WspolnotaRozliczenieTHead.js";
import WspolnotaRozliczenieTBody from "./WspolnotaRozliczenieTBody.js";
import WspolnotaRozliczenieTFooter from "./WspolnotaRozliczenieTFooter.js";

const WspolnotaRozliczenieTable = ( props ) => {

  const { stawki, stawkiJednorazowe, czynszeMsc, ind, udzialyKontaAkt,   
    idw, wspolnota, lokale, ulice, grupy, przelewyWspolnota, czynszeWspolnota,  
    mieszkancy, zestaw, wybraneRozliczenieWody } = props;

  return (
    <div className="table-container">
      <table className="lista tabela naleznosci">
        <WspolnotaRozliczenieTHead 
          stawki={stawki}
          stawkiJednorazowe={stawkiJednorazowe}
          czynszeMsc={czynszeMsc}
          ind={ind}
        />
        <WspolnotaRozliczenieTBody
          idw={idw}
          wspolnota={wspolnota}
          lokale={lokale}
          ulice={ulice}
          grupy={grupy}
          udzialyKontaAkt={udzialyKontaAkt}
          stawki={stawki}
          stawkiJednorazowe={stawkiJednorazowe}
          przelewyWspolnota={przelewyWspolnota}
          czynszeWspolnota={czynszeWspolnota} 
          czynszeMsc={czynszeMsc}
          mieszkancy={mieszkancy}
          ind={ind}
          zestaw={zestaw}
        />
        <WspolnotaRozliczenieTFooter
          udzialyKontaAkt={udzialyKontaAkt}
          stawki={stawki}
          stawkiJednorazowe={stawkiJednorazowe}
          czynszeMsc={czynszeMsc}
          ind={ind}
          wybraneRozliczenieWody={wybraneRozliczenieWody}
        />
      </table>
    </div>
  )
}

export default WspolnotaRozliczenieTable;